/**
 * Categories V2 - Разделенные подкатегории для лучшей фильтрации
 * Поддерживает множественное присвоение категорий
 */

export const categoriesV2 = [
  {
    id: 'cars',
    name: 'Cars',
    icon: 'car',
    subcategories: [
      { id: 'cars-new', name: 'New Cars' },
      { id: 'cars-used', name: 'Used Cars' },
      { id: 'cars-spare-parts', name: 'Car Spare Parts' },
      { id: 'cars-accessories', name: 'Car Accessories' },
    ],
    order: 1,
  },
  {
    id: 'bikes',
    name: 'Bikes',
    icon: 'motorcycle',
    subcategories: [
      { id: 'bikes-motorcycles', name: 'Motorcycles' },
      { id: 'bikes-scooters', name: 'Scooters' },
      { id: 'bikes-bicycles', name: 'Bicycles' },
      { id: 'bikes-spare-parts', name: 'Bike Spare Parts' },
    ],
    order: 2,
  },
  {
    id: 'properties',
    name: 'Properties',
    icon: 'house',
    subcategories: [
      { id: 'properties-sale-houses', name: 'For Sale: Houses' },
      { id: 'properties-sale-apartments', name: 'For Sale: Apartments' },
      { id: 'properties-rent-houses', name: 'For Rent: Houses' },
      { id: 'properties-rent-apartments', name: 'For Rent: Apartments' },
      { id: 'properties-lands', name: 'Lands & Plots' },
      { id: 'properties-new-projects', name: 'New Projects' },
      { id: 'properties-rent-commercial', name: 'For Rent: Commercial' },
      { id: 'properties-sale-commercial', name: 'For Sale: Commercial' },
      { id: 'properties-guest-houses', name: 'PG & Guest Houses' },
    ],
    order: 3,
  },
  {
    id: 'electronics',
    name: 'Electronics & Appliances',
    icon: 'electronics',
    subcategories: [
      // Разделенные подкатегории из "TVs, Video - Audio"
      { id: 'electronics-tvs', name: 'TVs' },
      { id: 'electronics-video', name: 'Video' },
      { id: 'electronics-audio', name: 'Audio' },
      // Другие подкатегории
      { id: 'electronics-kitchen', name: 'Kitchen & Other Appliances' },
      { id: 'electronics-computers', name: 'Computers & Laptops' },
      { id: 'electronics-cameras', name: 'Cameras & Lenses' },
      { id: 'electronics-games', name: 'Games & Entertainment' },
      { id: 'electronics-fridges', name: 'Fridges' },
      { id: 'electronics-computer-accessories', name: 'Computer Accessories' },
      { id: 'electronics-acs', name: 'ACs' },
      { id: 'electronics-washing-machines', name: 'Washing Machines' },
    ],
    order: 4,
  },
  {
    id: 'mobiles',
    name: 'Mobiles',
    icon: 'mobile',
    subcategories: [
      { id: 'mobiles-phones', name: 'Mobile Phones' },
      { id: 'mobiles-accessories', name: 'Mobile Accessories' },
      { id: 'mobiles-tablets', name: 'Tablets' },
    ],
    order: 5,
  },
  {
    id: 'commercial-vehicles',
    name: 'Commercial Vehicles & Spares',
    icon: 'truck',
    subcategories: [
      { id: 'commercial-vehicles', name: 'Commercial & Other Vehicles' },
      { id: 'commercial-spare-parts', name: 'Spare Parts' },
    ],
    order: 6,
  },
  {
    id: 'jobs',
    name: 'Jobs',
    icon: 'jobs',
    subcategories: [
      { id: 'jobs-data-entry', name: 'Data entry & Back office' },
      { id: 'jobs-sales', name: 'Sales & Marketing' },
      { id: 'jobs-bpo', name: 'BPO & Telecaller' },
      { id: 'jobs-driver', name: 'Driver' },
      { id: 'jobs-office-assistant', name: 'Office Assistant' },
      { id: 'jobs-teacher', name: 'Teacher' },
      { id: 'jobs-cook', name: 'Cook' },
      { id: 'jobs-it', name: 'IT Engineer & Developer' },
      { id: 'jobs-hotel', name: 'Hotel & Travel Executive' },
      { id: 'jobs-other', name: 'Other Jobs' },
    ],
    order: 7,
  },
  {
    id: 'furniture',
    name: 'Furniture',
    icon: 'house',
    subcategories: [
      { id: 'furniture-sofa-dining', name: 'Sofa & Dining' },
      { id: 'furniture-beds-wardrobes', name: 'Beds & Wardrobes' },
      { id: 'furniture-decor', name: 'Home Decor & Garden' },
      { id: 'furniture-kids', name: 'Kids Furniture' },
      { id: 'furniture-other', name: 'Other Household Items' },
    ],
    order: 8,
  },
  {
    id: 'fashion',
    name: 'Fashion',
    icon: 'house',
    subcategories: [
      { id: 'fashion-men', name: 'Men' },
      { id: 'fashion-women', name: 'Women' },
      { id: 'fashion-kids', name: 'Kids' },
    ],
    order: 9,
  },
  {
    id: 'pets',
    name: 'Pets',
    icon: 'house',
    subcategories: [
      { id: 'pets-dogs', name: 'Dogs' },
      { id: 'pets-fishes', name: 'Fishes & Aquarium' },
      { id: 'pets-food', name: 'Pet Food & Accessories' },
      { id: 'pets-other', name: 'Other Pets' },
    ],
    order: 10,
  },
  {
    id: 'books-sports-hobbies',
    name: 'Books, Sports & Hobbies',
    icon: 'house',
    subcategories: [
      { id: 'hobbies-books', name: 'Books' },
      { id: 'hobbies-gym', name: 'Gym & Fitness' },
      { id: 'hobbies-musical-instruments', name: 'Musical Instruments' },
      { id: 'hobbies-sports', name: 'Sports Equipment' },
      { id: 'hobbies-other', name: 'Other Hobbies' },
    ],
    order: 11,
  },
  {
    id: 'services',
    name: 'Services',
    icon: 'truck',
    subcategories: [
      { id: 'services-education', name: 'Education & Classes' },
      { id: 'services-tutoring', name: 'Tutoring & Lessons' },
      { id: 'services-language-courses', name: 'Language Courses' },
      { id: 'services-music-art', name: 'Music & Art Classes' },
      { id: 'services-professional-training', name: 'Professional Training' },
      { id: 'services-travel', name: 'Tours & Travel' },
      { id: 'services-transport-moving', name: 'Transport & Moving' },
      { id: 'services-cleaning', name: 'Cleaning Services' },
      { id: 'services-home-cleaning', name: 'Home Cleaning' },
      { id: 'services-electronics-repair', name: 'Electronics Repair & Services' },
      { id: 'services-computer-phone-repair', name: 'Computer & Phone Repair' },
      { id: 'services-appliance-repair', name: 'Appliance Repair' },
      { id: 'services-health', name: 'Health & Beauty' },
      { id: 'services-hair-salon', name: 'Hair & Salon' },
      { id: 'services-spa-massage', name: 'Spa & Massage' },
      { id: 'services-fitness', name: 'Fitness & Personal Training' },
      { id: 'services-renovation', name: 'Home Renovation & Repair' },
      { id: 'services-plumbing', name: 'Plumbing' },
      { id: 'services-electrical', name: 'Electrical' },
      { id: 'services-painting', name: 'Painting & Decorating' },
      { id: 'services-carpentry', name: 'Carpentry' },
      { id: 'services-gardening', name: 'Gardening & Landscaping' },
      { id: 'services-legal-financial', name: 'Legal & Financial Services' },
      { id: 'services-accounting-taxes', name: 'Accounting & Taxes' },
      { id: 'services-photography', name: 'Photography & Video' },
      { id: 'services-events', name: 'Event Services' },
      { id: 'services-catering', name: 'Catering' },
      { id: 'services-automotive', name: 'Automotive Services' },
      { id: 'services-pet', name: 'Pet Services' },
      { id: 'services-it-web', name: 'IT & Web Services' },
      { id: 'services-other', name: 'Other Services' },
    ],
    order: 12,
  },
  {
    id: 'kids',
    name: 'Kids',
    icon: 'house',
    subcategories: [
      { id: 'kids-toys', name: 'Toys & Games' },
      { id: 'kids-clothing', name: 'Baby Clothing' },
      { id: 'kids-strollers', name: 'Strollers & Carriers' },
      { id: 'kids-school', name: 'School Supplies' },
      { id: 'kids-accessories', name: 'Kids Accessories' },
    ],
    order: 13,
  },
];

// Карта миграции старых подкатегорий на новые
export const categoryMigrationMap = {
  // Electronics - разделение "TVs, Video - Audio"
  'TVs, Video - Audio': ['electronics-tvs', 'electronics-video', 'electronics-audio'],
  
  // Другие подкатегории (прямое отображение)
  'Kitchen & Other Appliances': 'electronics-kitchen',
  'Computers & Laptops': 'electronics-computers',
  'Cameras & Lenses': 'electronics-cameras',
  'Games & Entertainment': 'electronics-games',
  'Fridges': 'electronics-fridges',
  'Computer Accessories': 'electronics-computer-accessories',
  'ACs': 'electronics-acs',
  'Washing Machines': 'electronics-washing-machines',
  
  // Bikes
  'Motorcycles': 'bikes-motorcycles',
  'Scooters': 'bikes-scooters',
  'Bicycles': 'bikes-bicycles',
  'Spare Parts': 'bikes-spare-parts',
  
  // Mobiles
  'Mobile Phones': 'mobiles-phones',
  'Accessories': 'mobiles-accessories',
  'Tablets': 'mobiles-tablets',
  
  // Commercial Vehicles
  'Commercial & Other Vehicles': 'commercial-vehicles',
  'Spare Parts': 'commercial-spare-parts',
  
  // Jobs
  'Data entry & Back office': 'jobs-data-entry',
  'Sales & Marketing': 'jobs-sales',
  'BPO & Telecaller': 'jobs-bpo',
  'Driver': 'jobs-driver',
  'Office Assistant': 'jobs-office-assistant',
  'Teacher': 'jobs-teacher',
  'Cook': 'jobs-cook',
  'IT Engineer & Developer': 'jobs-it',
  'Hotel & Travel Executive': 'jobs-hotel',
  'Other Jobs': 'jobs-other',
  
  // Furniture
  'Sofa & Dining': 'furniture-sofa-dining',
  'Beds & Wardrobes': 'furniture-beds-wardrobes',
  'Home Decor & Garden': 'furniture-decor',
  'Kids Furniture': 'furniture-kids',
  'Other Household Items': 'furniture-other',
  
  // Fashion
  'Men': 'fashion-men',
  'Women': 'fashion-women',
  'Kids': 'fashion-kids',
  
  // Pets
  'Dogs': 'pets-dogs',
  'Fishes & Aquarium': 'pets-fishes',
  'Pet Food & Accessories': 'pets-food',
  'Other Pets': 'pets-other',
  
  // Books, Sports & Hobbies
  'Books': 'hobbies-books',
  'Gym & Fitness': 'hobbies-gym',
  'Musical Instruments': 'hobbies-musical-instruments',
  'Sports Equipment': 'hobbies-sports',
  'Other Hobbies': 'hobbies-other',
  
  // Services
  'Education & Classes': 'services-education',
  'Tutoring & Lessons': 'services-tutoring',
  'Language Courses': 'services-language-courses',
  'Music & Art Classes': 'services-music-art',
  'Professional Training': 'services-professional-training',
  'Tours & Travel': 'services-travel',
  'Transport & Moving': 'services-transport-moving',
  'Cleaning Services': 'services-cleaning',
  'Home Cleaning': 'services-home-cleaning',
  'Computer & Phone Repair': 'services-computer-phone-repair',
  'Appliance Repair': 'services-appliance-repair',
  'Hair & Salon': 'services-hair-salon',
  'Spa & Massage': 'services-spa-massage',
  'Fitness & Personal Training': 'services-fitness',
  'Plumbing': 'services-plumbing',
  'Electrical': 'services-electrical',
  'Painting & Decorating': 'services-painting',
  'Carpentry': 'services-carpentry',
  'Gardening & Landscaping': 'services-gardening',
  'Legal & Financial Services': 'services-legal-financial',
  'Accounting & Taxes': 'services-accounting-taxes',
  'Photography & Video': 'services-photography',
  'Event Services': 'services-events',
  'Catering': 'services-catering',
  'Automotive Services': 'services-automotive',
  'Pet Services': 'services-pet',
  'IT & Web Services': 'services-it-web',
  'Electronics Repair & Services': 'services-electronics-repair',
  'Health & Beauty': 'services-health',
  'Home Renovation & Repair': 'services-renovation',
  'Other Services': 'services-other',
  
  // Kids
  'Toys & Games': 'kids-toys',
  'Baby Clothing': 'kids-clothing',
  'Strollers & Carriers': 'kids-strollers',
  'School Supplies': 'kids-school',
  'Kids Accessories': 'kids-accessories',
};

// Функция для получения новых подкатегорий из старых
export const migrateSubcategory = (oldSubcategory) => {
  const mapped = categoryMigrationMap[oldSubcategory];
  if (Array.isArray(mapped)) {
    return mapped; // Возвращает массив для множественного присвоения
  }
  return mapped ? [mapped] : [];
};

// Функция для получения всех подкатегорий категории
export const getSubcategoriesV2 = (categoryId) => {
  const category = categoriesV2.find(c => c.id === categoryId);
  return category?.subcategories || [];
};

// Функция для получения подкатегории по ID
export const getSubcategoryById = (subcategoryId) => {
  for (const category of categoriesV2) {
    const subcategory = category.subcategories.find(sc => sc.id === subcategoryId);
    if (subcategory) {
      return subcategory;
    }
  }
  return null;
};